import React from 'react';
import Modal from 'react-bootstrap/Modal';

import AsyncSelect from "react-select/async";
import { asyncSelectCustomStyles } from "../../util/styles";
import { reactSelectIcons } from "../../util/reactSelectPrimeIcons";

import './Style.css';

class ModalDemerito extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            operadorSelecionado: null,
            empreendimentoSelecionado: null,
            motivosSelecionados: [],

            form: {
                operador_id: '',
                building_id: '',
                motivos: [],
                comentario: null,
            },
        };
    }

    debounce = (key, callback, delay = 250) => {
        clearTimeout(this.searchTimeouts?.[key]);

        this.searchTimeouts = this.searchTimeouts || {};

        this.searchTimeouts[key] = setTimeout(() => {
            callback();
        }, delay);
    };

    handleInputChange = (event) => {
        const {
            name,
            value,
        } = event.target;

        this.setState({
            form: {
                ...this.state.form,
                [name]: value,
            },
        });
    };

    searchUsers = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                '/autocomplete-users',
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar operadores:', error);
            return [];
        }
    };

    searchBuildings = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                `/autocomplete-with-ids/${this.props.cityPeriod.city_id}`,
                {
                    params: {
                        search: inputValue,
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar empreendimentos:', error);
            return [];
        }
    };

    searchMotivos = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) {
            return [];
        }

        try {
            const response = await axios.get(
                `/autocomplete-motivos`,
                {
                    params: {
                        search: inputValue,
                        tipo: 'Demérito',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar motivos:', error);
            return [];
        }
    };

    handleOperadorChange = (selectedOption) => {
        this.setState({
            operadorSelecionado: selectedOption,

            form: {
                ...this.state.form,
                operador_id: selectedOption ? selectedOption.id : '',
            },
        });
    };

    handleEmpreendimentoChange = (selectedOption) => {
        this.setState({
            empreendimentoSelecionado: selectedOption,

            form: {
                ...this.state.form,
                building_id: selectedOption ? selectedOption.id : '',
            },
        });
    };

    handleMotivosChange = (selectedOptions) => {
        this.setState({
            motivosSelecionados: selectedOptions || [],
            form: {
                ...this.state.form,
                motivos: selectedOptions || [],
            },
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const {
            form,
        } = this.state;

        if (!form.operador_id) {
            alert('Selecione um operador antes de continuar!');
            return;
        }

        if (!form.building_id) {
            alert('Selecione um empreendimento antes de continuar!');
            return;
        }

        if (!form.motivos || form.motivos.length === 0) {
            alert('Selecione ao menos um motivo antes de continuar!');
            return;
        }

        await this.props.onSubmit(form);
    };

    handleClose = () => {
        if (this.props.loading) {
            return;
        }

        this.setState({
            operadorSelecionado: null,
            empreendimentoSelecionado: null,
            motivosSelecionados: [],

            form: {
                operador_id: '',
                building_id: '',
                motivos: [],
                comentario: null,
            },
        });

        this.props.onClose();
    };

    render() {

        const {
            open,
            loading,
        } = this.props;

        const {
            form,
            operadorSelecionado,
            empreendimentoSelecionado,
        } = this.state;

        return (
            <div style={{ zIndex: '9999' }}>
                <Modal
                    show={open}
                    onHide={this.handleClose}
                    dialogClassName="modal-demerito"
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Demérito
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <form
                            className="form-modal"
                            onSubmit={this.handleSubmit}
                        >
                            <div className="formulario">
                                <div className="form-group">
                                    <label>Operador</label>
                                    <AsyncSelect
                                        value={operadorSelecionado}
                                        loadOptions={this.searchUsers}
                                        isClearable
                                        getOptionLabel={(option) => option.text}
                                        getOptionValue={(option) => String(option.id)}
                                        onChange={this.handleOperadorChange}
                                        className="autocomplete"
                                        styles={asyncSelectCustomStyles}
                                        placeholder="Buscar"
                                        components={reactSelectIcons}
                                        noOptionsMessage={() => "Digite para buscar..."}
                                        loadingMessage={() => 'Carregando...'}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Empreendimento</label>
                                    <AsyncSelect
                                        value={empreendimentoSelecionado}
                                        loadOptions={this.searchBuildings}
                                        isClearable
                                        getOptionLabel={(option) => option.text}
                                        getOptionValue={(option) => String(option.id)}
                                        onChange={this.handleEmpreendimentoChange}
                                        styles={asyncSelectCustomStyles}
                                        className="autocomplete"
                                        placeholder="Buscar"
                                        components={reactSelectIcons}
                                        noOptionsMessage={() => "Digite para buscar..."}
                                        loadingMessage={() => 'Carregando...'}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Motivo / Critério</label>
                                    <AsyncSelect
                                        isMulti
                                        closeMenuOnSelect={false}
                                        value={form.motivos}
                                        loadOptions={this.searchMotivos}
                                        isClearable
                                        getOptionLabel={(option) => option.text}
                                        getOptionValue={(option) => String(option.id)}
                                        onChange={this.handleMotivosChange}
                                        styles={asyncSelectCustomStyles}
                                        placeholder="Selecione"
                                        components={reactSelectIcons}
                                        noOptionsMessage={() => "Digite para buscar..."}
                                        loadingMessage={() => 'Carregando...'}
                                        className="autocomplete"
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Comentário</label>
                                    <textarea
                                        className=""
                                        placeholder="Digite"
                                        rows="3"
                                        cols="3"
                                        name="comentario"
                                        onChange={this.handleInputChange}
                                    >{form.comentario}</textarea>
                                </div>

                                <div className="form-buttons">
                                    <button
                                        type="submit"
                                        className="btn btn-success btn-round background-brain"
                                    >
                                        {loading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin"></i>{' '}
                                                Processando...
                                            </>
                                        ) : (
                                            'Salvar'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default ModalDemerito;